export default {
  allStates: 'Všetky stavy',
  zeroStates: 'Vybraných je 0 stavov',
};
